module.exports = __webpack_public_path__ + "img/icon_ok.98989091.svg";